module.exports = __webpack_public_path__ + "image-2ee95b5b2cf3.png";